import * as FormHelpers from './forms/helpers';
import * as Attribution from './driftrock_attribution';

function track_event(event_name, params) {
  const settings = Driftrock.tracking_settings || {}
  params = params || {}
  const url = `${Driftrock.settings.base_url}/v2/event`;
  const firstTouch = Attribution.get_first_touch() || {};
  const adClickIds = Attribution.get_ad_click_ids() || {};

  const default_metadata = {
    "fbclid": adClickIds.fbclid,
    "gclid": adClickIds.gclid,
    "li_fat_id": adClickIds.li_fat_id,
    "sc_cid": adClickIds.sc_cid,
    "utm_campaign": firstTouch.utm_campaign,
    "utm_content": firstTouch.utm_content,
    "utm_medium": firstTouch.utm_medium,
    "utm_source": firstTouch.utm_source,
    "utm_term": firstTouch.utm_term || firstTouch.utm_keyword
  }

  const event_type = params.event_type || settings.event_type || "action";
  const source_id = params.source_id || settings.source_id;
  const metadata = {...(settings.metadata || {}), ...(params.metadata || {}), ...default_metadata};
  const fields = params.fields || {};

  fetch(`${Driftrock.settings.base_url}/v2/event`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${Driftrock.settings.api_key}`,
    },
    body: JSON.stringify({
      "event_type": event_type,
      "event_name": event_name,
      "source_id": source_id,
      "metadata": metadata,
      "fields": fields
    })
  });
}

export { track_event }
